import React, { memo } from 'react';
import styles from './consultantReport.module.css';

function ReportSection({ title, icon: Icon, children, className = '', divider = true }) {
    if (!children) return null;
    return (
        <section
            className={`${styles.reportSection} ${className}`.trim()}
            aria-label={title}>
            {title ? (
                <header className={styles.reportSectionHeader}>
                    {Icon ? <Icon className={styles.reportSectionIcon} aria-hidden /> : null}
                    <h3 className={styles.reportSectionTitle}>{title}</h3>
                </header>
            ) : null}
            {children}
            {divider ? null : null}
        </section>
    );
}

export default memo(ReportSection);
